import { render, staticRenderFns } from "./ManagerShiftEditorProgram.vue?vue&type=template&id=71b1959f&lang=pug&"
import script from "./ManagerShiftEditorProgram.vue?vue&type=script&lang=js&"
export * from "./ManagerShiftEditorProgram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports